import { Reducer } from 'redux'

import { RefinanciamentoTypes } from '@store/refinanciamento/actions'

import { ContratacaoTypes } from './types'

export interface ContratacaoState {
  loadingContratacao: boolean
}

const initialState: ContratacaoState = {
  loadingContratacao: false,
}

const contratacaoReducer: Reducer<ContratacaoState> = (state = initialState, action) => {
  switch (action.type) {
    case ContratacaoTypes.CONTRATACAO_REQUEST:
      return {
        ...state,
        loadingContratacao: true,
      }
    case ContratacaoTypes.CONTRATACAO_SUCCESS:
    case ContratacaoTypes.CONTRATACAO_ERROR:
      return {
        ...state,
        loadingContratacao: false,
      }
    case RefinanciamentoTypes.RESET:
      return { ...initialState }
    default:
      return state
  }
}

export default contratacaoReducer
